import { useSelector } from 'react-redux'
import { useMemo } from 'react'

import { selectCustomerNotificationsSettings } from '@/features/domain/territory'
import { NotificationFormValues } from '@/notificationForms'

export type NotCompletedNotificationValues = ReturnType<typeof useNotCompletedNotificationValues>

/**
 * That hook grabs notCompletedNotification values from the domain and returns them
 */
export function useNotCompletedNotificationValues(): NotificationFormValues {
  const notificationSettings = useSelector(selectCustomerNotificationsSettings)

  return useMemo(() => {
    const { includeMessageUnsubscriptionInstructions, ...rest } =
      notificationSettings['notCompletedSettings']

    return {
      ...rest,
      windowOfCommitmentToleranceMins: '30',
      notificationCutoffMins: 0,
      proximityThresholdMins: '10',
      toleranceMins: 'No',
      windowOfCommitmentSnapToMins: 0,
      alwaysNotifyAfterCutoff: false,
      // includeMessageUnsubscriptionInstructions should alwayes be true for phone
      includeMessageUnsubscriptionInstructionsPhone: true,
      // includeMessageUnsubscriptionInstructions should be based on the value from the domain for email
      includeMessageUnsubscriptionInstructionsEmail: includeMessageUnsubscriptionInstructions,
    }
  }, [notificationSettings])
}
